import { render, staticRenderFns } from "./VendorsTable.vue?vue&type=template&id=700b5ac6&scoped=true"
import script from "./VendorsTable.vue?vue&type=script&lang=js"
export * from "./VendorsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700b5ac6",
  null
  
)

export default component.exports